<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Create Customer Account</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="accountCreationForm" autocomplete="off">
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Type</label>
                    <select class="mvd_form-control" [formControl]="accountCreationForm.controls['accountType']" (change)="accountTypeChange($event.target.value)">
                        <option value="">Select..</option>
                        <option *ngFor="let type of selectableAccountTypes" value="{{type.id}}">{{type.displayValue}}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Name</label>
                    <input class="mvd_form-control" type="text" [formControl]="accountCreationForm.controls['accountName']" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Account Description</label>
                    <input class="mvd_form-control" type="text" [formControl]="accountCreationForm.controls['AccountDescription']" />
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!accountCreationForm.valid" [isLoading]="showButtonLoading" [btnText]="'Save'" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>